import { CartItemReview } from '@/components/cart'
import { useCartContext } from '@/context/CartContext'
import CartItemProvider from '@/context/CartItemContext'
import { useCart } from 'hooks/graphql/legacy-api'
import { formatCost } from 'utils'

export default function CartTotal() {
	const { cart } = useCart()

	const { cartTotalPrice } = useCartContext()

	return (
		<div className="flex justify-between w-full border-t border-black-rt/20 py-8 mt-8">
			<div className="w-full font-medium text-black-rt">Cart total</div>
			<div className="w-full flex flex-col justify-end text-right">
				{cart?.items.length > 0 &&
					cart.items.map((item) => (
						<CartItemProvider cartItem={item} key={item.id}>
							<div className="hidden">
								<CartItemReview />
							</div>
						</CartItemProvider>
					))}

				<div>
					<span className="desktop-h4 text-right text-black-rt">{formatCost(cartTotalPrice)}</span>
				</div>
			</div>
		</div>
	)
}
